import { isPending } from "App/apiMiddleware";
import actionTypes from "./actionTypes";
export const getInProgress = (state, documentId) => isPending(state, `${actionTypes.CREATE_SUMMARY_REPORT_OBJECTS}_${documentId}`);
